import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  RejectPendingIssueTypeSuggestionInput,
  rejectPendingIssueTypeSuggestionMutation,
  rejectPendingIssueTypeSuggestionMutation$data,
} from './__generated__/rejectPendingIssueTypeSuggestionMutation.graphql'

export function commitRejectPendingIssueTypeSuggestionMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: RejectPendingIssueTypeSuggestionInput
  onError?: (error: Error) => void
  onCompleted?: (response: rejectPendingIssueTypeSuggestionMutation$data) => void
}) {
  return commitMutation<rejectPendingIssueTypeSuggestionMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation rejectPendingIssueTypeSuggestionMutation($input: RejectPendingIssueTypeSuggestionInput!) {
        rejectPendingIssueTypeSuggestion(input: $input) {
          issue {
            id
            pendingTypeSuggestions {
              state
              actor {
                id
                login
              }
              rationale
              issueType {
                id
                name
                color
              }
            }
          }
        }
      }
    `,
    variables: {input},
    onError: error => onError?.(error),
    onCompleted: response => onCompleted?.(response),
  })
}
